import * as React from 'react'
import { Fragment, useEffect, useState } from 'react'
// import { useTranslation } from 'react-i18next'
import { useTranslation } from 'react-i18next/hooks';

import Button from '../Button/Button';
// import ImagePhotoAuthInfo from '../../UploadImage/ImagePhotoAuthInfo';
import FilesUploadNameChange from './FilesUploadNameChange';
import Loader from '../Loader/Loader';

import { useStore } from '../../hook-store/store';
import { s3fileUpload2 } from '../../util/file-upload-util/bucket-upload-util';
import { mimeTypes } from '../../util/file/mime-type';
// import { BACKEND_URL } from '../../App';

import FileUploadKuraInfo from './FileUploadKuraInfo';

import { getUploadedObjectFile } from '../../util/uploaded-object/uploaed-object';
import { 
  getUploadedKuraBucketFile,
  
} from '../../util/group/kura-bucket-file';
import { 
  getOriginalFileNameFromKey,
} from '../../util/bucket/bucket-object-util';

import { 
  SOCKET_GROUP_URL,
  KURASTORAGE_BACKENDURL,
  KURAIMAGEPHOTO_BACKENDURL,
  KURASTORAGE_URL,
  KURAIMAGEPHOTO_URL,
} from '../../App';

import { marks } from '../../images/marks';

import './FilesUploadAction.css';
// import classes from './BgRemoveUpload.module.css';

const FilesUploadAction = (props) => {
  const { 
    filePaths,
    uploadApp,
    kuraFileInfo,
    groupRoomId,
  } = props


  const [t] = useTranslation('translation')

  const [store, dispatch] = useStore();
  const { 
    bucketName, 
    topLevels, 
    totalSizeGB, 
    limitGB,
    // selectedPrefix,
  } = store.bucketObjectStore;
  const { gLoading, isAuth } = store.uiStore;
  const { serviceBucketsDataList } = store.serviceBucketsStore;
  const { 
    selectedKuraFileData,
    isGroupMember,
   } = store.groupStore;

  const [kuraStorageBucketData, setKuraStorageBucketData] = useState();
  const [resultMessage, setResultMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const [fileForUpload, setFileForUpload] = useState();
  const [isImageFile, setIsImageFile] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);

  let canUpload = false;

  if (isAuth && kuraStorageBucketData) {
    canUpload = true;
  }

  console.log('canUpload', canUpload)
  // console.log(uploadFiles)

  // console.log('bucketName', bucketName, canUpload, isAuth, kuraStorageBucketData);

  useEffect(() => {
    if (gLoading) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  },[gLoading]);

  useEffect(() => {

    const kuraStorageBucketData = serviceBucketsDataList.find(element => {
      return element.bucket === localStorage.getItem('userId');
    });
  
    let bucketName = '';
    
    if (kuraStorageBucketData) {
      //@ts-ignore
      dispatch('SET_BUCKETNAME', kuraStorageBucketData.bucket);
      setKuraStorageBucketData(kuraStorageBucketData);
    }

  },[serviceBucketsDataList]);


  // useEffect(() => {
  //   if (uploadFiles?.length > 0 && !uploadNameFile) {
  //     createUploadNameFile(uploadFiles[0], uploadApp);
  //   }
  // },[uploadFiles]);


  useEffect(() => {
    if (canUpload && filePaths?.length > 0 && !kuraFileInfo.key) {
      getUploadedFileHandler(filePaths[0]);
    }
  },[filePaths, canUpload, kuraFileInfo]);

  useEffect(() => {
    if (kuraFileInfo && kuraFileInfo.key && groupRoomId && isGroupMember) {
      getKuraBucketFileHandler(
        kuraFileInfo,
        groupRoomId,
      );
    }
  },[kuraFileInfo, groupRoomId]);


  const getUploadedFileHandler = async(filePath) => {
    try {
      setIsLoading(true);
      setErrorMessage('');


      const resData = await getUploadedObjectFile(
        SOCKET_GROUP_URL,
        localStorage.getItem('token'),
        'xxx',
        filePath,
      );

      if (resData) {
        const buffer = new Uint8Array(resData.data.buffer.data).buffer;
        const blob = new Blob([buffer], { type: resData.data.mimeType });
        // console.log(blob)
        const pathSplit = filePath.split('.');
        const ext = pathSplit.pop();

        const file = new File(
          [blob], 
          `group-upload-${Date.now()}.${ext}`, 
          { type: blob.type },
        );

        console.log(file)
        setFileForUpload(file);

        if (blob.type.startsWith('image/')) {
          setIsImageFile(true);
        }
      }

      setIsLoading(false);

    } catch(err) {
      console.log(err);
      setIsLoading(false);
      setErrorMessage('get file failed');
      throw err;
    }
  };


  const getKuraBucketFileHandler = async (
      kuraFileInfo,
      groupRoomId,
    ) => {
      try {

        //// reuse selectedKuraFileData file
        if (selectedKuraFileData && selectedKuraFileData.file &&
          selectedKuraFileData.bucket === kuraFileInfo.bucket &&
          selectedKuraFileData.key === kuraFileInfo.key
        ) {
          setFileForUpload(selectedKuraFileData.file);

          if (selectedKuraFileData.mimeType?.split('/')[0] === 'image') {
            setIsImageFile(true);
          }

          return;
        }


        setIsLoading(true);
        setErrorMessage('');

        const resData = await getUploadedKuraBucketFile(
          SOCKET_GROUP_URL,
          localStorage.getItem('token'),
          kuraFileInfo.bucket,
          kuraFileInfo.key,
          kuraFileInfo.initialKey,
          groupRoomId,
        );
  
      if (resData) {
          const buffer = new Uint8Array(resData.data.buffer.data).buffer;
          const blob = new Blob([buffer], { type: resData.data.mimeType });
          // console.log(blob)
          const pathSplit = kuraFileInfo.key.split('.');
          const ext = pathSplit.pop();

          // const fileName = decodeURI(
          //   getOriginalFileNameFromKey(resData.data.foundKey)
          // );
          const fileName = decodeURI(
            getOriginalFileNameFromKey(kuraFileInfo.key)
          );

          const file = new File(
            [blob], 
            fileName,
            // `group-upload-${Date.now()}.${ext}`, 
            { type: blob.type },
          );

          console.log(file)
          setFileForUpload(file);

  
          if (selectedKuraFileData?.bucket === kuraFileInfo.bucket &&
              selectedKuraFileData.key === kuraFileInfo.key
            ) {
              dispatch('SET_SELECTEDKURAFILEDATA', {
                ...selectedKuraFileData,
                file: file,
              });
          } else {
              dispatch('SET_SELECTEDKURAFILEDATA', {
                ...kuraFileInfo,
                file: file,
              });
          }
       

          if (blob.type.startsWith('image/')) {
            setIsImageFile(true);
          }
        }
  
        setIsLoading(false);
  
      } catch(err) {
        console.log(err);
        setIsLoading(false);
        setErrorMessage('Get file failed.');

        if (err.message === 'bucket-object-not-found') {
          setErrorMessage('Get file failed. File not found. File might be deleted.');
        }
        throw err;
      }
  };


  const filesUploadHandler = async (path, files, uploadApp) => {
    try {
      // setIsLoading(true);
      setResultMessage('');

      //@ts-ignore
      dispatch('SET_GLOADING', true);

      let resultsForAction = {
        fileUpload: null,
      };


      // if (!file) {
      //   throw new Error('error occured');
      // }

      const file = files[0]

      console.log(file, uploadApp, file.type);
      // throw new Error('error-error')
      console.log(path, files);
      // throw new Error('error-error');

      if (!files || files.length === 0) {
        throw new Error('upload file is required');
      }

      if (files.length > 10) {
        throw new Error('Upload limit is 10 file');
      }

      let uploadSizeGB = 0;
      // let limitGB = 0.1;

      for (const file of files) {
        uploadSizeGB = uploadSizeGB + file.size / 10**9;
      }

      if ((totalSizeGB + uploadSizeGB) > limitGB) {
        throw new Error('Total file sizes are more than limit');
      }

      let result;
      let backendUrl = KURASTORAGE_BACKENDURL;
      let userBucketName = bucketName;

      if (isImageFile) {
        backendUrl = KURAIMAGEPHOTO_BACKENDURL;
        userBucketName = bucketName + '-image-photo';
      }


      result = await s3fileUpload2(
        backendUrl,
        localStorage.getItem('token'),
        path,
        [file],
        userBucketName,
        dispatch,
        uploadApp,
      );

      console.log(result);
      
      resultsForAction.fileUpload = result.data;

      //@ts-ignore
      dispatch('SHOW_NOTIFICATION', {
        status: '',
        title: 'upload success',
        message: '',
      });

      setResultMessage('upload success');

      setTimeout(() => {
        //@ts-ignore
        dispatch('CLEAR_NOTIFICATION');
      },1000 * 3);

      // showUploadMoadlHandler(false);
      // setIsLoading(false);
      //@ts-ignore
      dispatch('SET_GLOADING', false);

    } catch(err) {
      console.log(err);

      //@ts-ignore
      dispatch('SHOW_NOTIFICATION', {
        status: 'error',
        title: `upload failed. ${err.message && err.message}`,
        message: '',
      });

      setTimeout(() => {
        //@ts-ignore
        dispatch('CLEAR_NOTIFICATION');
      },1000 * 10);

      setResultMessage('upload failed');
      
      // setIsLoading(false);
      //@ts-ignore
      dispatch('SET_GLOADING', false);
    }

  };


  let filesUploadActionBody

  filesUploadActionBody = (
    <div>
      {canUpload && fileForUpload && (
        <div>
            <div className='filesUploadActionSection'>
              {isImageFile && (
                <div className='fileUploadActionMessage'>
                  <span>
                    {t('fileUploadAction05', 'User can upload file for storing image files')}
                  </span>
                  {' '}to{' '}
                  <a 
                    href={KURAIMAGEPHOTO_URL}
                    target='_blank' rel="noreferrer noopener"
                  >
                    Kura Image Photo
                  </a>.
                  <div>{t('fileUploadAction06', 'Same account with this page can be used to login.')}</div>
                  {/* <div>
                    <span
                      onClick={() => {
                        setIsImageFile(false);
                      }}
                    >
                      (or, select-kura-storage-as-destination)
                    </span>
                  </div> */}
                </div>
              )}
              {!isImageFile && (
                <div className='fileUploadActionMessage'>
                  <span>
                    {t('fileUploadAction07', 'User can upload file for storing files')} 
                  </span>
                  {' '}to{' '}
                  <a href={KURASTORAGE_URL}
                    target='_blank' rel="noreferrer noopener"
                  >
                    Kura Storage
                  </a>.
                  <div>{t('fileUploadAction06', 'Same account with this page can be used to login.')}</div>
                </div>
              )}
            </div>
            <div className='filesUploadActionSection'>
              <div>{t('fileUploadAction08', 'File name')}</div>
              <div>
                <strong>{fileForUpload.name}</strong>
              </div>
            </div>

            <FilesUploadNameChange 
              uploadNameFile={fileForUpload}
              setUploadNameFile={setFileForUpload}
            />

            <div className='filesUploadActionSection'>
              <div>
                {t('fileUploadAction15', 'Upload destination')}
              </div>
              {isImageFile && <strong>Kura Image Photo</strong>}
              {!isImageFile && <strong>Kura Storage</strong>}


              <div>
                {isImageFile && (
                  <span
                    onClick={() => { setIsImageFile(false); }}
                  >
                    ({t('fileUploadAction16', 'change')}{' '}
                    to Kura Storage)
                  </span>
                )}
                {!isImageFile && (
                  <span
                    onClick={() => { setIsImageFile(true); }}
                  >
                    ({t('fileUploadAction16', 'change')}{' '}
                    to Kura Image Photo)
                  </span>
                )}
              </div>
            </div>

            <div className='filesUploadActionSection'></div>
            
            <div className='filesUploadActionSection'>
              <Button mode="raised" design="" type="submit" 
                // className='btnBase'
                // style={{ fontSize: "1.25rem", fontWeight: "bold", border: "1px solid gray" }}
                disabled={isLoading}
                onClick={() => { 
                  filesUploadHandler(
                    '', 
                    [fileForUpload],
                    uploadApp,
                  );
                }}
              >
                {t('fileUploadAction04', 'Upload')} {marks.uploadMark}
              </Button>
            </div>
        </div>
      )}
      {isLoading && (
        <div>
          <Loader />
          {t('fileUploadAction17', 'preparing file')}
          ...
        </div>
      )}
      {resultMessage && (
        <div>
          <strong>{resultMessage}</strong>
        </div>
      )}
      {errorMessage && (
        <div>
          <strong>{errorMessage}</strong>
        </div>
      )}

      {/* {!canUpload && (
        <div>
          <ImagePhotoAuthInfo />
        </div>
      )} */}

      {!isAuth && (
        <FileUploadKuraInfo />
      )}
    </div>
  )

  return (
    <Fragment>
      <div>{filesUploadActionBody}</div>

      {/* {fileForUpload && (
        <img style={{height:"50px"}}
          src={URL.createObjectURL(fileForUpload)}
        />
        // <audio 
        // style={{height:"50px"}}
        //   controls
        //   src={URL.createObjectURL(fileForUpload)}
        // />
      )} */}
    </Fragment>
  )
}

export default FilesUploadAction;
